import { AdminTemplate, BankRedirectAddBulkUploadForm } from "../../components"

export const BankRedirectAddBulkUpload = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'Sanal POS Toplu Banka Yönlendirme',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <BankRedirectAddBulkUploadForm />
    </AdminTemplate>
  )
}
